import script from "./ow-file-imports.vue?vue&type=script&setup=true&lang=js"
export * from "./ow-file-imports.vue?vue&type=script&setup=true&lang=js"

import "./ow-file-imports.vue?vue&type=style&index=0&id=2679cd7b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2679cd7b"]])

export default __exports__